/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseReportItem } from './ResponseReportItem';
import {
    ResponseReportItemFromJSON,
    ResponseReportItemFromJSONTyped,
    ResponseReportItemToJSON,
    ResponseReportItemToJSONTyped,
} from './ResponseReportItem';

/**
 * 
 * @export
 * @interface ResponseGetReportItemsCsvListResponse
 */
export interface ResponseGetReportItemsCsvListResponse {
    /**
     * 
     * @type {Array<ResponseReportItem>}
     * @memberof ResponseGetReportItemsCsvListResponse
     */
    items?: Array<ResponseReportItem>;
}

/**
 * Check if a given object implements the ResponseGetReportItemsCsvListResponse interface.
 */
export function instanceOfResponseGetReportItemsCsvListResponse(value: object): value is ResponseGetReportItemsCsvListResponse {
    return true;
}

export function ResponseGetReportItemsCsvListResponseFromJSON(json: any): ResponseGetReportItemsCsvListResponse {
    return ResponseGetReportItemsCsvListResponseFromJSONTyped(json, false);
}

export function ResponseGetReportItemsCsvListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetReportItemsCsvListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ResponseReportItemFromJSON)),
    };
}

export function ResponseGetReportItemsCsvListResponseToJSON(json: any): ResponseGetReportItemsCsvListResponse {
    return ResponseGetReportItemsCsvListResponseToJSONTyped(json, false);
}

export function ResponseGetReportItemsCsvListResponseToJSONTyped(value?: ResponseGetReportItemsCsvListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ResponseReportItemToJSON)),
    };
}

